import { render, staticRenderFns } from "./YourTask.vue?vue&type=template&id=d27a0b06&scoped=true"
import script from "./YourTask.vue?vue&type=script&lang=js"
export * from "./YourTask.vue?vue&type=script&lang=js"
import style0 from "./Task.scss?vue&type=style&index=0&id=d27a0b06&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27a0b06",
  null
  
)

export default component.exports